import MarkdownRender from 'LuxKit/MarkdownRender'
import { rem } from 'polished'
import styled from 'styled-components'

/**
 * Extends MarkdownRender to add consistent vertical spacing between headings, paragraphs, lists and other block elements.
 */
const SpacedMarkdownRender = styled(MarkdownRender)`
  && {
    strong {
      font-weight: ${props => props.theme.font.primary.weight.superBold};
    }
    h2, h3, h4, h5, h6 {
      margin-top: ${rem(20)};
    }
    p, li, ul, ol, p + p, p + ul {
      margin-top: ${rem(16)};
    }
    ul ul > li::before {
      content: "▪";
    }
    > :first-child { margin-top: 0; }
  }
`

export default SpacedMarkdownRender
